<app-content-header [backLabel]="isWorkflow ? 'app_cancel' : 'app_back'" [historyBack]="!isWorkflow" (backEvent)="onBack()"
[headline]="'nfr_one_prepare_headline' | i18next"></app-content-header>

<div class="row align-items-stretch">
  <div class="col-sm-12 col-lg-4 mb-3 mb-lg-0">
    <app-icon-card header="nfr_one_create_trial_headline" icon="fa fa-plus">
      <div [innerHtml]="'nfr_one_create_trial_content' | i18next"></div>
    </app-icon-card>
  </div>
  <div class="col-sm-12 col-lg-4 mb-3 mb-lg-0">
    <app-icon-card header="nfr_one_upgrade_headline" icon="fa-solid fa-arrow-trend-up">
      <div [innerHtml]="'nfr_one_upgrade_content' | i18next"></div>
    </app-icon-card>
  </div>
  <div class="col-sm-12 col-lg-4 mb-3 mb-lg-0">
    <app-icon-card header="nfr_one_credit_headline" icon="fa fa-coins">
      <div [innerHtml]="'nfr_one_credit_content' | i18next: { cu: getNfrOnePartnerCu, partnerLevel: partnerLevelTranslation }"></div>
    </app-icon-card>
  </div>
</div>


@if (isWorkflow) {
  <div class="d-flex flex-column flex-md-row justify-content-md-end align-items-md-center px-3 px-md-0 pt-3 pb-3 mt-3 mb-3">
    <app-pascom-checkbox class="pt-1 mb-2 mb-md-2" [text]="'nfr_one_accept_prepare_content' | i18next" (acceptChanged)="accept($event)"></app-pascom-checkbox>
    <button class="btn btn-outline-primary" (click)="onNext()" [disabled]="!accepted">{{ 'create_trial_btn' | i18next}}</button>
  </div>
}
